<section class="seminar-reviews-testimonial">
  <div class="box">
    <div class="box-content">
      <h3 class="box-content__heading"
        ><span>{{ 'SEMINAR_REVIEWS_TESTIMONIAL.HEADING' | translate }}</span></h3
      >
    </div>
    <div class="box-wrapper">
      <div class="swiper-container-main">
        <swiper-container class="swiper" appSwiper [config]="config" init="false">
          <ng-container *ngFor="let item of serviceList">
            <swiper-slide class="swiper-slide">
              <div class="box-wrapper__card">
                <div class="card-impressed"
                  ><span> {{ item.data.impressed.iv }}</span>
                </div>

                <div class="card-reivew">
                  <div class="card-reivew__image">
                    <picture>
                      <source [srcset]="item.data.imageWebP.iv" type="image/webp" />
                      <img
                        [src]="item.data.image.iv"
                        width="100%"
                        loading="lazy"
                        class="card-reivew__image--layout"
                        [alt]="item.data.nameCustomers?.iv"
                        [title]="item.data.nameCustomers?.iv"
                      />
                    </picture>
                  </div>
                  <div class="card-reivew__detail">
                    <div class="card-reivew__detail--name"> {{ item.data.nameCustomers?.iv }}</div>
                    <div class="card-reivew__detail--firm">{{ item.data.nameFirm?.iv }}</div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </ng-container>
        </swiper-container>
        <div class="swiper-button-prev">
          <i class="cursor fas fa-arrow-left"></i>
        </div>
        <div class="swiper-button-next">
          <i class="cursor fas fa-arrow-right"></i>
        </div>
      </div>
    </div>
  </div>
</section>
